import { Outlet } from 'react-router-dom'

import { DeviceCatalogRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useQuery } from 'modules/core/hooks/useQuery'

import PageLoading from 'modules/layout/components/Page/Loading'

const DeviceCatalogRootPage = () => {
  const { data, loading } = useQuery(DeviceCatalogRootPageDocument, {
    fetchPolicy: 'cache-first',
  })

  const canSeeDeviceCatalog = data?.itManagement._policies.sidebarSeeDeviceCatalogItem.can

  if (loading) return <PageLoading />

  return (
    <AuthorizeUser authorizeFn={() => canSeeDeviceCatalog ?? false}>
      <Outlet />
    </AuthorizeUser>
  )
}

export default DeviceCatalogRootPage
